import React from 'react';
import { createUseStyles, multiply, clsx } from '@pushpay/styles';
import { Text } from './text';
const useParagraphStyles = createUseStyles(theme => ({
  paragraph: ({
    textStyle
  }) => {
    const {
      LINE_HEIGHT,
      SIZE: fontSize
    } = theme.TYPOGRAPHY.TEXT_STYLES[textStyle];
    return {
      marginTop: multiply(fontSize, LINE_HEIGHT)
    };
  }
}));
export const Paragraph = ({
  type = 'BODY_1',
  className: classNameProp,
  classes: classesProp,
  ...rest
}) => {
  const classes = useParagraphStyles(classesProp, {
    textStyle: type
  });
  const className = clsx(classNameProp, classes.paragraph);
  return /*#__PURE__*/React.createElement(Text, Object.assign({
    type: type,
    className: className,
    component: "p"
  }, rest));
};